export default __webpack_public_path__ + "static/media/new-item.1e973ef3.jpeg";